import axios from 'axios';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
const baseURL = process.env.REACT_APP_BASE_URL;


interface LevelItem {
  level: number;
  total_bet_amt: number;
}

const Level = () => {
  const [levels, setLevels] = useState<LevelItem[]>([]);
  const [editLevel, setEditLevel] = useState<LevelItem | null>(null);
  const navigate = useNavigate();
  const [newLevel, setNewLevel] = useState<LevelItem>({
      level: 0,
      total_bet_amt: 0,
    });

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    navigate('/login');
  };

  // Fetch levels from the API
  const fetchLevels = async () => {
    try {
      const response = await axios.get(`${baseURL}/admin/getLevel`);
      if (response.data) {
        setLevels(response.data.data);
      } else {
        toast('Failed to fetch levels.');
      }
    } catch (error) {
      console.error('Error fetching levels:', error);
      toast('Error fetching levels.');
    }
  };

  useEffect(() => {
    fetchLevels();
  }, []);

  // Handle input changes for editing levels
  const handleEditLevelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (editLevel) {
      const { name, value } = e.target;
      setEditLevel((prevLevel) => ({
        ...prevLevel!,
        [name]: value ? parseFloat(value) : 0,
      }));
    }
  };

    // Handle input changes for new bonus
    const handleNewBonusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      setNewLevel((prevBonus) => ({
        ...prevBonus,
        [name]: value ? parseInt(value) : 0,
      }));
    };

  // Update an existing level
  const handleUpdateLevel = async (e: React.FormEvent) => {
    e.preventDefault();
    if (editLevel) {
      try {
        const response = await axios.post(
          `${baseURL}/admin/updateLevel/${editLevel.level}`,
          editLevel
        );
        if (response.data) {
          toast('Level updated successfully!');
          setEditLevel(null); // Clear the edit state
          fetchLevels();
        } else {
          toast('Failed to update level.');
        }
      } catch (error) {
        console.error('Error updating level:', error);
        toast('Error updating level.');
      }
    }
  };

  // Delete a level
  const handleDeleteLevel = async (id: number) => {
    try {
      const response = await axios.delete(`${baseURL}/admin/deleteLevel/${id}`);
      if (response.data) {
        toast('Level deleted successfully!');
        fetchLevels();
      } else {
        toast('Failed to delete level.');
      }
    } catch (error) {
      console.error('Error deleting level:', error);
      toast('Error deleting level.');
    }
  };

  const handleAddLevel = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newLevel?.level || !newLevel?.total_bet_amt) {
      toast('Please provide valid inputs for the new level.');
      return;
    }

    try {
      const response = await axios.post(
        `${baseURL}/admin/createLevel`,
        newLevel
      );
      if (response.data.status) {
        toast('Level added successfully!');
        setNewLevel({
          level: 0,
          total_bet_amt: 0,
        });
        fetchLevels();
      } else {
        toast('Failed to add deposit bonus.');
      }
    } catch (error : any) {
      console.error('Error adding deposit bonus:', error);
      toast(error.response.data.message);
    }
  };

  const filteredLevels = levels.filter(level => level.level > -1);

  return (
    <div className="ml-0 lg:ml-[256px] p-4">
      <h2 className="text-2xl font-semibold mb-4 text-white">Level</h2>
      <hr className="p-5" />

      <div className='mb-8'>
        <h3 className='text-xl text-white'>Add New Deposit Bonus</h3>
        <form onSubmit={handleAddLevel} className='space-y-4'>
          <div>
            <label className='text-white'>Level</label>
            <input
              type='number'
              name='level'
              value={newLevel.level}
              onChange={handleNewBonusChange}
              className='border rounded p-2 w-full'
            />
          </div>
          <div>
            <label className='text-white'>Total Bet Amount</label>
            <input
              type='number'
              name='total_bet_amt'
              value={newLevel.total_bet_amt}
              onChange={handleNewBonusChange}
              className='border rounded p-2 w-full'
            />
          </div>
          
          <button
            type='submit'
            className='bg-blue-500 text-white py-2 px-4 rounded'
          >
            Add Level
          </button>
        </form>
      </div>

      {/* Edit Existing Level Form */}
      {editLevel && (
        <div className="mb-8">
          <h3 className="text-xl text-white">Edit Level</h3>
          <form onSubmit={handleUpdateLevel} className="space-y-4">
            
            <div>
              <label className="text-white">Level</label>
              <input
                type="number"
                name="level"
                value={editLevel?.level}
                disabled
                onChange={handleEditLevelChange}
                className="border bg-gray-500 rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-white">Total Bet Amount</label>
              <input
                type="number"
                name="total_bet_amt"
                value={editLevel?.total_bet_amt}
                onChange={handleEditLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            
            <button type="submit" className="bg-green-500 text-white py-2 px-4 rounded">
              Update Level
            </button>
            <button
              type="button"
              onClick={() => setEditLevel(null)}
              className="bg-red-500 text-white py-2 px-4 rounded ml-2"
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Display Levels */}
      <div>
        {levels.length > 0 ? (
          <table className="table-auto w-full text-white text-center">
            <thead>
              <tr>
                <th className="border px-4 py-2">Level</th>
                <th className="border px-4 py-2">Total Bet Amount</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              
              {filteredLevels.map((level) => (
                <tr key={level.level}>
                  <td className="border px-4 py-2">{level.level}</td>
                  <td className="border px-4 py-2">{level.total_bet_amt}</td>
                 
                  <td className="border px-4 py-2">
                    <button
                      onClick={() => setEditLevel(level)}
                      className="bg-yellow-500 text-white py-1 px-3 rounded"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDeleteLevel(level.level)}
                      className="bg-red-500 text-white py-1 px-3 rounded ml-2"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-white">No levels available at the moment.</p>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default Level;
